import { render, staticRenderFns } from "./editChainProduct.vue?vue&type=template&id=5906c012&scoped=true"
import script from "./editChainProduct.vue?vue&type=script&lang=js"
export * from "./editChainProduct.vue?vue&type=script&lang=js"
import style0 from "./editChainProduct.vue?vue&type=style&index=0&id=5906c012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906c012",
  null
  
)

export default component.exports